import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ParseHTML from "../../global/components/ParseHTML";
import React from 'react';

const NO_ROLES_TEXT: string = process.env.REACT_APP_ILP_NO_ROLES_TEXT!;
const MCC_BOILERPLATE = process.env.REACT_APP_MCC_INFO!;
export default function NoRoles() {
    return (
        <Box padding={2}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(NO_ROLES_TEXT)}</Typography>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(MCC_BOILERPLATE)}</Typography>
        </Box>
    );
}